module.exports = __webpack_public_path__ + "media/sound.92d83839.mp3";